import React from 'react';
import App from 'next/app';
import '../styles.css';
import Router from 'next/router';
import { trackPageView } from '../helpers/track';

class MyApp extends App {
  componentDidMount() {
    if (window.location.pathname === '/') {
      window.location.href = 'https://recrutei.com.br/para-empresas/';
    } else {
      Router.onRouteChangeComplete = url => {
        trackPageView(url);
      };
    }
  }

  render() {
    const { Component, pageProps } = this.props;
    return <Component {...pageProps} />;
  }
}
export default MyApp;
